import React, { useId, useState } from "react";
import { CalendarDays, ChevronDown } from "lucide-react";
import { sessionLine } from "../lib/groupSessions";

/**
 * A cohort's exact sessions, folded behind "Vezi toate sesiunile (N)".
 *
 * Folded because the row it sits in is a summary people scan to choose a
 * group; eight dates each would turn the schedule into a wall. Renders
 * nothing for a group without sessions — its weekly text already says it all.
 */
export default function GroupSessionsList({ sessions, testid = "group-sessions", className = "" }) {
  const [open, setOpen] = useState(false);
  const listId = useId();
  if (!sessions?.length) return null;
  const n = sessions.length;
  return (
    <div className={className}>
      <button
        type="button"
        onClick={() => setOpen((v) => !v)}
        aria-expanded={open}
        aria-controls={listId}
        className="inline-flex items-center gap-1 rounded text-xs font-semibold text-[#7A4986] hover:underline focus:outline-none focus-visible:ring-2 focus-visible:ring-[#965EA7]"
        data-testid={`${testid}-toggle`}
      >
        <CalendarDays size={13} aria-hidden="true" />
        {open ? "Ascunde sesiunile" : `Vezi toate sesiunile (${n})`}
        <ChevronDown size={13} aria-hidden="true" className={`transition-transform ${open ? "rotate-180" : ""}`} />
      </button>
      {open && (
        <ol id={listId} className="mt-2 space-y-1 text-[13px] text-[#373A45]" data-testid={`${testid}-list`}>
          {sessions.map((s, i) => (
            <li key={`${s.date}-${s.start_time}`} className="flex gap-2">
              <span className="w-5 shrink-0 text-right tabular-nums text-[#6B7280]">{i + 1}.</span>
              <span>
                {sessionLine(s)}
                {s.note && <span className="block text-xs font-semibold text-[#7A4986]">{s.note}</span>}
              </span>
            </li>
          ))}
        </ol>
      )}
    </div>
  );
}
